////ROUTING
import routing from './header-content.routes';

////CONTROLLER
import HeaderContentController from './header-content.controller';

////DIRECTIVES
import headerContent from './header-content.directive';

////SERVICES

export default angular
    .module('headerContent', [
        headerContent
    ])
    .config(routing)
    .controller('HeaderContentController', HeaderContentController)
    .name;


// WEBPACK FOOTER //
// ./src/app/views/header-content/index.js